module.exports = "<span ng-bind-html=\"vm.activeDate\"></span> ";


//////////////////
// WEBPACK FOOTER
// ./src/app.retailer.common/components/campaign-active-date/campaign-active-date.html
// module id = 23
// module chunks = 0 1 3 4